module.exports = __webpack_public_path__ + "img/火箭.6221b8c6.png";